import React from 'react';
import { ButtonStyled } from './Styled';
import { ButtonProps } from '../../../types';

const Button = (props: ButtonProps) => {
  const { children, onClick, loading = false, disabled = false } = props;

  return (
    <ButtonStyled className={loading ? 'loading' : ''} onClick={onClick} disabled={disabled}>
      {children}
    </ButtonStyled>
  );
};

export default Button;
export { Button };
